module.exports = __webpack_public_path__ + "static/img/Tag.66ec5cd4.svg";